import React from 'react'

import Layout from '../components/Layout'
import Text from '../components/Text'
import Button from '../components/Button'
import ActionBar from '../components/ActionBar'

const Instructions = ({ onNext }) => {
  return (
    <Layout>
      <Layout>
        <Text large>Please get ready to record your voice</Text>

        <Layout>
        <ol>
          <li>If possible, move to a quiet place, without any distractions or background noise</li>
          <li>Check that your microphone is at an arm's length from your mouth</li>
          <li>Speak clearly, and avoid sharing personal information in the recordings</li>
          <li>Please allow access to your microphone when asked</li>
        </ol>
        </Layout>

        <ul>
          <li>
            There will be three recording sections, where you will:
            <ul>
              <li>Cough for 3 times</li>
              <li>Breathe heavily for 3 times</li>
              <li>
                Describe a photo in a sentence or two
                <ul>
                  <li>You can use your native language</li>
                </ul>
              </li>
            </ul>
          </li>
          <li><strong>On each section press "Start" and wait for the countdown until you start speaking</strong></li>
          <li>Press "Stop" when you are done with a recording</li>
        </ul>
      </Layout>

      <Layout highlight>
        <Text>
          <strong>Attention:</strong> in-app browsers (such as Facebook) are not supported
        </Text>
      </Layout>

      <ActionBar active>
        <Layout />
        <Button onClick={onNext}>Next</Button>
      </ActionBar>
    </Layout>
  )
}

export default Instructions
